import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { useExecutePromptMutation, TemplateEngineContext } from '~/types/types';
import { useShowDebugging } from '~/functions/accounts';
import { renderTrustedMarkdown } from '~/functions/markdown';
export default /*#__PURE__*/_defineComponent({
  __name: 'Question',
  props: {
    id: {
      type: [Number, String],
      required: false,
      default: 0
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    tooltip: {
      type: String,
      default: ''
    },
    tooltipTitle: {
      type: String,
      default: ''
    },
    isMandatory: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ixId: {
      type: String,
      default: ''
    },
    promptTemplate: {
      type: Object,
      required: false
    },
    fundId: {
      type: Number,
      required: false,
      default: null
    },
    impactSolutionId: {
      type: Number,
      required: false,
      default: null
    },
    impactId: {
      type: Number,
      required: false,
      default: null
    },
    context: {
      type: String,
      required: false,
      default: function _default() {
        return TemplateEngineContext.Fund;
      }
    },
    accountId: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['ai-suggestion'],
  setup: function setup(__props, _ref) {
    var emits = _ref.emit;
    var props = __props;
    var showDebugging = useShowDebugging();
    var executePromptResponse = ref(null);
    var showPromptDialog = ref(false);
    var _useExecutePromptMuta = useExecutePromptMutation(),
      mutate = _useExecutePromptMuta.mutate,
      loading = _useExecutePromptMuta.loading;
    var showPromptButton = computed(function () {
      var _props$promptTemplate;
      return showDebugging.value || ((_props$promptTemplate = props.promptTemplate) === null || _props$promptTemplate === void 0 ? void 0 : _props$promptTemplate.isActive);
    });
    var showLockIcon = computed(function () {
      var _props$promptTemplate2;
      return showDebugging.value && !((_props$promptTemplate2 = props.promptTemplate) !== null && _props$promptTemplate2 !== void 0 && _props$promptTemplate2.isActive);
    });
    var executePrompt = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(promptTemplateId) {
        var _result$data, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!props.disabled) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.prev = 2;
              _context.next = 5;
              return mutate({
                input: {
                  promptTemplateId: promptTemplateId,
                  impactSolutionId: props.impactSolutionId,
                  fundId: props.fundId,
                  impactId: props.impactId,
                  context: props.context,
                  accountId: props.accountId
                }
              });
            case 5:
              result = _context.sent;
              executePromptResponse.value = (result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.executePrompt) || null;
              if (executePromptResponse.value) {
                showPromptDialog.value = true;
              }
              _context.next = 14;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              console.error('Failed to execute prompt:', _context.t0);
              executePromptResponse.value = null;
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 10]]);
      }));
      return function executePrompt(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var formatDebugInfo = function formatDebugInfo(response) {
      var debugData = {
        tokenUsage: response.tokenUsage,
        latencyMs: response.latencyMs,
        cacheHit: response.cacheHit,
        promptTemplateId: response.promptTemplateId,
        version: response.version,
        model: response.model,
        renderedSystem: response.renderedSystem,
        renderedUser: response.renderedUser,
        createdAt: response.createdAt,
        promptAccepted: response.promptAccepted,
        sanitizerInfo: response.sanitizerInfo,
        sanitizedRenderedUser: response.sanitizedRenderedUser
      };
      return JSON.stringify(debugData, null, 2);
    };
    var handleAccept = function handleAccept() {
      var _executePromptRespons, _executePromptRespons2, _executePromptRespons3, _executePromptRespons4;
      emits('ai-suggestion', (_executePromptRespons = executePromptResponse === null || executePromptResponse === void 0 ? void 0 : (_executePromptRespons2 = executePromptResponse.value) === null || _executePromptRespons2 === void 0 ? void 0 : _executePromptRespons2.response) !== null && _executePromptRespons !== void 0 ? _executePromptRespons : '', (_executePromptRespons3 = executePromptResponse === null || executePromptResponse === void 0 ? void 0 : (_executePromptRespons4 = executePromptResponse.value) === null || _executePromptRespons4 === void 0 ? void 0 : _executePromptRespons4.id) !== null && _executePromptRespons3 !== void 0 ? _executePromptRespons3 : '');
      showPromptDialog.value = false;
      executePromptResponse.value = null;
    };
    var handleCancel = function handleCancel() {
      showPromptDialog.value = false;
      executePromptResponse.value = null;
    };
    return {
      __sfc: true,
      props: props,
      emits: emits,
      showDebugging: showDebugging,
      executePromptResponse: executePromptResponse,
      showPromptDialog: showPromptDialog,
      mutate: mutate,
      loading: loading,
      showPromptButton: showPromptButton,
      showLockIcon: showLockIcon,
      executePrompt: executePrompt,
      formatDebugInfo: formatDebugInfo,
      handleAccept: handleAccept,
      handleCancel: handleCancel,
      renderTrustedMarkdown: renderTrustedMarkdown
    };
  }
});